import { ChangeDetectionStrategy, Component } from '@angular/core';
import { VisualStyleEditorComponent } from '../../base/VisualStyleEditor.component';
import { AgGridPivotTableVisual } from '../pivotTable/PivotTableVisual.component';
import { PivotColumnDisplay, TableLayout } from '../shared';
import { AgGridTableVisual } from '../table/TableVisual.component';

@Component({
  selector: 'pbir-visual__ag-grid__table-style-editor',
  templateUrl: './TableStyleEditorComponent.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgGridTableStyleEditorComponent extends VisualStyleEditorComponent<
  AgGridTableVisual.Options,
  AgGridTableVisual.State,
  AgGridTableVisual.Style> {
  readonly TableLayoutOptions = TableLayout.list;
  readonly PivotColumnDisplayOptions = PivotColumnDisplay.list;

  get tableLayout() { return this.style().tableLayout; }

  readonly isPivot = false;
  get pivotColumnDisplay() { return null as any; }
}

@Component({
  selector: 'pbir-visual__ag-grid__pivot-table-style-editor',
  templateUrl: './TableStyleEditorComponent.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgGridPivotTableStyleEditorComponent extends VisualStyleEditorComponent<
  AgGridPivotTableVisual.Options,
  AgGridPivotTableVisual.State,
  AgGridPivotTableVisual.Style> {
  readonly TableLayoutOptions = TableLayout.list;
  readonly PivotColumnDisplayOptions = PivotColumnDisplay.list;

  get tableLayout() { return this.style().tableLayout; }

  readonly isPivot = true;
  get pivotColumnDisplay() { return this.style().pivotColumnDisplay; }
}
